import { render, staticRenderFns } from "./checkout-order.vue?vue&type=template&id=f8dc0a04&"
import script from "./checkout-order.vue?vue&type=script&lang=js&"
export * from "./checkout-order.vue?vue&type=script&lang=js&"
import style0 from "./checkout-order.vue?vue&type=style&index=0&id=f8dc0a04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports